import api from './config';

export const companiesAPI = {
  // Listar empresas (Admin)
  getAll: async () => {
    const token = localStorage.getItem('token');
    const response = await api.get('/companies', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  // Criar empresa (Admin)
  create: async (data) => {
    const token = localStorage.getItem('token');
    const response = await api.post('/companies', data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  // Buscar empresa do usuário atual
  getMyCompany: async () => {
    const token = localStorage.getItem('token');
    const response = await api.get('/companies/me', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  // Atualizar empresa do usuário atual
  updateMyCompany: async (data) => {
    const token = localStorage.getItem('token');
    const response = await api.put('/companies/me', data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  // Detalhes da empresa (Admin)
  getById: async (id) => {
    const token = localStorage.getItem('token');
    const response = await api.get(`/companies/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  // Atualizar empresa (Admin)
  update: async (id, data) => {
    const token = localStorage.getItem('token');
    const response = await api.put(`/companies/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  // Vincular usuário à empresa (Admin)
  linkUser: async (companyId, userId) => {
    const token = localStorage.getItem('token');
    const response = await api.put(`/companies/${companyId}/users/${userId}`, {}, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  // Desvincular usuário da empresa (Admin)
  unlinkUser: async (companyId, userId) => {
    const token = localStorage.getItem('token');
    const response = await api.delete(`/companies/${companyId}/users/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  // Deletar empresa (Admin)
  delete: async (id) => {
    const token = localStorage.getItem('token');
    const response = await api.delete(`/companies/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  // Criar usuário na empresa (Master)
  createUser: async (companyId, userData) => {
    const token = localStorage.getItem('token');
    const response = await api.post(`/companies/${companyId}/users`, userData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
};

export default companiesAPI;


